$(document).ready(function() {
  $('.privacy-policy-button').on('click', function(e) {
    e.preventDefault();
    $('#pills-privacy-tab').click();
  });
});
